import { render, staticRenderFns } from "./ProductMappingTable.vue?vue&type=template&id=320e2c48&scoped=true"
import script from "./ProductMappingTable.vue?vue&type=script&lang=js"
export * from "./ProductMappingTable.vue?vue&type=script&lang=js"
import style0 from "./ProductMappingTable.vue?vue&type=style&index=0&id=320e2c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320e2c48",
  null
  
)

export default component.exports